import { tv } from "@ui/lib/tv";
import { cx } from "@ui/utils/cx";

const skeleton = tv({
  base: "animate-pulse bg-neutral-100",
  variants: {
    rounded: {
      sm: "rounded",
      md: "rounded-lg",
      lg: "rounded-xl",
      xl: "rounded-3xl",
      full: "rounded-full",
    },
  },
  defaultVariants: {
    rounded: "sm",
  },
});

export interface SkeletonBoxProps {
  className?: string;
  rounded?: "sm" | "md" | "lg" | "xl" | "full";
}

export function SkeletonBox({ className, rounded }: SkeletonBoxProps) {
  return <div className={skeleton({ rounded, className })} />;
}

export interface SkeletonTextProps {
  className?: string;
  /** Number of lines (1-4). Values above 4 render as 4. */
  lines?: number;
}

export function SkeletonText({ className, lines = 1 }: SkeletonTextProps) {
  const n = Math.min(Math.max(lines, 1), 4);
  return (
    <div className={cx("flex flex-col gap-1.5", className)}>
      {n >= 2 && <SkeletonBox className="h-5 w-full" />}
      {n >= 3 && <SkeletonBox className="h-5 w-full" />}
      {n >= 4 && <SkeletonBox className="h-5 w-full" />}
      {n === 1 ? <SkeletonBox className="h-5 w-full" /> : <SkeletonBox className="h-5 w-2/3" />}
    </div>
  );
}
